import React from 'react';

// Two visual variants share one shape:
//  - hero:    YOUR row when ranking. Yellow surface, big score, distance subtitle.
//  - compact: every other row. Cream surface, condensed.
const LeaderboardRow = ({
  rank,
  name,
  score = 0,
  distance,
  palette = { color: 'var(--c-blue)', emoji: '🦅' },
  isMe = false,
  variant,
}) => {
  const mode = variant || (isMe ? 'hero' : 'compact');

  if (mode === 'hero') {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '10px 12px',
        background: 'var(--c-yellow)',
        border: 'var(--border-ink)',
        borderRadius: 'var(--radius-btn)',
        boxShadow: 'var(--shadow-hard)',
        animation: 'penFadeSlideIn 420ms var(--ease-pop) both',
      }}>
        <div style={{
          fontFamily: 'var(--font-display)', fontSize: 18, lineHeight: 1,
          background: 'var(--c-ink)', color: 'var(--c-yellow)',
          padding: '8px 10px', borderRadius: 8, minWidth: 36, textAlign: 'center',
          flexShrink: 0,
        }}>#{rank}</div>
        <div style={{
          width: 32, height: 32, borderRadius: 999,
          background: palette.color,
          border: 'var(--border-ink-sm)',
          display: 'grid', placeItems: 'center', fontSize: 16,
          flexShrink: 0,
        }}>{palette.emoji}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{
            fontFamily: 'var(--font-display)', fontSize: 15, letterSpacing: 0.4,
            color: 'var(--c-ink)',
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }}>YOU</div>
          {distance != null && (
            <div style={{
              fontFamily: 'var(--font-mono)', fontSize: 9, fontWeight: 700,
              color: 'var(--c-ink)', opacity: 0.7, letterSpacing: 0.3,
              marginTop: 1,
            }}>{Number(distance).toFixed(1)} OFF</div>
          )}
        </div>
        <div style={{
          fontFamily: 'var(--font-display)', fontWeight: 900, fontSize: 22,
          padding: '8px 12px', borderRadius: 8,
          background: 'var(--c-ink)', color: 'var(--c-yellow)',
          minWidth: 60, textAlign: 'center', lineHeight: 1,
          flexShrink: 0,
        }}>+{score}</div>
      </div>
    );
  }

  // compact
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8,
      padding: '6px 10px',
      background: 'var(--c-cream)',
      border: 'var(--border-ink-sm)',
      borderRadius: 'var(--radius-chip)',
    }}>
      <div style={{
        fontFamily: 'var(--font-display)', fontSize: 12,
        background: 'var(--c-ink)', color: 'var(--c-cream)',
        padding: '3px 6px', borderRadius: 5, minWidth: 24, textAlign: 'center',
      }}>#{rank}</div>
      <div style={{
        width: 22, height: 22, borderRadius: 999,
        background: palette.color, border: 'var(--border-ink-sm)',
        display: 'grid', placeItems: 'center', fontSize: 11,
        flexShrink: 0,
      }}>{palette.emoji}</div>
      <div style={{
        flex: 1, fontFamily: 'var(--font-display)', fontSize: 12, letterSpacing: 0.3,
        color: 'var(--c-ink)',
        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
      }}>{(name || '—').toString().toUpperCase()}</div>
      <div style={{
        fontFamily: 'var(--font-mono)', fontWeight: 700, fontSize: 13,
        color: 'var(--c-ink)',
      }}>+{score}</div>
    </div>
  );
};

export default LeaderboardRow;
